const B_1 = [
    {
        title: '项目列表',
        path: '/bidding/zbr/zbproject/list'
    }
]

export default {
    path: 'zbproject',
    component: () => import(/*webpackChunkName: 'zbr-project'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/zbr/zbproject/list'),
            meta: {
                title: '招标项目列表',
                bread: B_1,
                topNav: true,
            },
        },
        {
            path:"linklist",
            component: () => import('@views/bidding/views/zbr/zbproject/linklist'),
            meta: {
                title: '添加项目',
                bread: B_1,
            },
        },
    ]
}
